import {Pipe, PipeTransform} from '@angular/core';
import {DateValue, formatDisplayDateTime} from './date-format';

/** The <app-date> text where only a string fits, e.g. inside an attribute: `title="... {{ x | appDate }}"`. */
@Pipe({name: 'appDate'})
export class AppDatePipe implements PipeTransform {
  transform(value: DateValue): string {
    return formatDisplayDateTime(value);
  }
}
